<footer class="footer-02 text-center">
    <div class="copyright"> 2021 © 
      <a routerlink="home" href="#/home">Brayan Taday</a>
    </div><div class="footer-social">
      <a target="_blank" href="https://www.facebook.com/Brayan.Taday.98">
        <i class="fab fa-facebook"></i>
      </a>
      <a target="_blank" href="https://twitter.com/Brayan___Taday">
        <i class="fab fa-twitter"></i>
      </a>
      <a target="_blank" href="https://www.instagram.com/Brayan___Taday/">
        <i class="fab fa-instagram"></i>
      </a>
      <a href="https://github.com/Bryan-Taday" target="_blank">
        <i class="fab fa-github"></i>
      </a>
    </div>
  </footer>
